import React from 'react'
import { Modal } from 'antd'
import styled from 'styled-components'
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min'
import { useSelector } from 'react-redux'
import GrowthEngineHumanDemoRow from 'src/components/growthEngine/GrowthEngineHumanDemoRow'
import { planDisplayName } from 'src/constants/planDisplay'

const StyledContainer = styled.div`
  padding: 16px;
`

const Title = styled.h2`
  font-size: 24px;
  font-weight: bold;
  margin-bottom: 12px;
`

const Paragraph = styled.p`
  font-size: 16px;
  color: #555;
  margin-bottom: 10px;
`

const Footer = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 30px;
`

const UpgradeButton = styled.button`
  background-color: ${({ theme }) => theme.colours.avocadoGreen};
  color: white;
  font-size: 16px;
  padding: 10px 24px;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  transition: background-color 0.3s ease;

  &:hover {
    background-color: ${({ theme }) => theme.colours.avocadoGreen};
  }
`

export const FREE_PLAN_ROLE_MODAL_TITLE =
  'Give each person exactly the access they need'

const liteName = planDisplayName('Free')

// Above antd's default modal (1000) and the Users role-select dropdown (1100)
// so Save on Free is not hidden behind Create custom role.
export const FREE_PLAN_ROLE_MODAL_Z_INDEX = 1200

const FreePlanRoleModal = ({ visible, onCancel }) => {
  const history = useHistory()
  const venueId = useSelector(state => state.venue?.venue?._id)

  const handleUpgrade = () => {
    onCancel()
    history.push(`/v/${venueId}/subscriptions/oms-plans`)
  }

  return (
    <Modal
      title={FREE_PLAN_ROLE_MODAL_TITLE}
      centered
      visible={visible}
      width={600}
      footer={null}
      zIndex={FREE_PLAN_ROLE_MODAL_Z_INDEX}
      onCancel={onCancel}
    >
      <StyledContainer>
        <Title>{FREE_PLAN_ROLE_MODAL_TITLE}</Title>
        <Paragraph>
          A custom role lets you name it and tick exactly what that person can
          access, so the team sees what they need and nothing more.
        </Paragraph>
        <Paragraph>
          {liteName} includes Admin, Head Chef / GM, Chef, Order Only, and
          Kitchen Porter. Starter, Growth, and Pro add custom roles.
        </Paragraph>
        <Footer>
          <UpgradeButton onClick={handleUpgrade}>View plans</UpgradeButton>
        </Footer>
        <GrowthEngineHumanDemoRow featureLabel='custom roles' />
      </StyledContainer>
    </Modal>
  )
}

export default FreePlanRoleModal
